import { render, staticRenderFns } from "./RewardEdit.vue?vue&type=template&id=38187097&"
import script from "./RewardEdit.vue?vue&type=script&lang=js&"
export * from "./RewardEdit.vue?vue&type=script&lang=js&"
import style0 from "./RewardEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports